import React from 'react';
import { Star, ExternalLink } from 'lucide-react';

// Google Business Profile data
const GOOGLE_BUSINESS = {
  name: 'Sunshine Dental Care',
  rating: 4.9,
  totalReviews: 127,
  address: '700 Sunrise Ave Ste E, Roseville, CA 95661',
  mapsUrl: 'https://maps.app.goo.gl/SbtoHJSiUWqmjXH66',
  writeReviewUrl: 'https://g.page/r/CZlD-WcJTzwPEB0/review'
};

const StarRating = ({ rating, size = 24 }) => {
  return (
    <div className="flex gap-1">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={size}
          className={i < Math.floor(rating) ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}
        />
      ))}
    </div>
  );
};

const GoogleReviewsSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white" id="reviews">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Compact Review Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            {/* Left side - Rating info */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
                <img 
                  src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png" 
                  alt="Google" 
                  className="w-8 h-8"
                />
                <span className="text-gray-500 font-medium">Google Reviews</span>
              </div>
              
              <div className="flex items-center justify-center md:justify-start gap-4 mb-3">
                <span className="text-5xl md:text-6xl font-bold text-gray-900">{GOOGLE_BUSINESS.rating}</span>
                <div>
                  <StarRating rating={GOOGLE_BUSINESS.rating} size={28} />
                  <p className="text-sm text-gray-500 mt-1">
                    {GOOGLE_BUSINESS.totalReviews} reviews
                  </p>
                </div>
              </div>
              
              <p className="text-gray-700 font-semibold">{GOOGLE_BUSINESS.name}</p>
              <p className="text-sm text-gray-500">{GOOGLE_BUSINESS.address}</p>
            </div>

            {/* Right side - CTA buttons */}
            <div className="flex flex-col gap-3 w-full md:w-auto">
              <a
                href={GOOGLE_BUSINESS.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-8 py-4 rounded-xl transition-all shadow-lg hover:shadow-xl"
                data-testid="read-reviews-google"
              >
                Read Reviews on Google
                <ExternalLink size={20} />
              </a>
              <a
                href={GOOGLE_BUSINESS.writeReviewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white border-2 border-gray-200 hover:border-cyan-300 text-gray-700 font-semibold px-8 py-4 rounded-xl transition-all"
                data-testid="write-review"
              >
                <Star size={18} />
                Write a Review
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviewsSection;
